import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateEditUseAltUsernamePassword = mutatorAction('updateEditUseAltUsernamePassword', function (useAltUsernamePassword) {
    var store = connectedAccountsStore();
    store.editAccountState.useAltUsernamePassword = useAltUsernamePassword;
});
//# sourceMappingURL=updateEditUseAltUsernamePassword.js.map